// Do not modify directly
// Generated from file: learnin.core.api/Controllers/LxpContent/Responses/LxpFacetResponse.cs

import {z} from 'zod';

export const LxpFacetResponseValueSchema = z.object({
  count: z.number(),
  id: z.string(),
  isSelected: z.boolean(),
  name: z.string(),
});
